import { StyledExplanation } from './Explanation.styled';

export default function Explanation({ translation }) {
  return (
    <StyledExplanation>
      <div className="translation">{translation.Translation}</div>
      <div
        className="explanation"
        dangerouslySetInnerHTML={{
          __html: translation.PartsTranslations,
        }}
      ></div>
    </StyledExplanation>
  );
}
